export default __webpack_public_path__ + "static/media/NeueHaasUnicaW02-Light.3818aef2.woff";